import { toast } from 'react-toastify';
import appApi from '../../../../../../../../api/app-api';
import externalExamGroupsStore from '../../../../../../../../stores/external-exam-groups-store';
import { CreateExternalExamGroupExamRequest } from '../../../../../../../../api/types/external-exams/external-exam-group-crud';

export const addExamToGroupOperation = async (
  groupId: number,
  request: CreateExternalExamGroupExamRequest,
  setLoading: (isLoading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.addExamToGroup(groupId, request);
    if (res.data.ok && res.data.body) {
      await externalExamGroupsStore.fetchGroups();
      toast.success(`הוספת מבחן למקבץ התבצעה בהצלחה`);
      onSuccess();
    } else {
      toast.error(`הוספת מבחן נכשלה, נסה שוב בעוד מספר רגעים...`);
    }
    setLoading(false);
  } catch (e) {
    toast.error('הוספת מבחן נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(`addExamToGroupOperation failed: ${e}`);
    setLoading(false);
  }
};
